import React from 'react'

const Info = () => (
  <svg viewBox="0 0 20 19" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 0C4.478 0 0 4.253 0 9.5S4.478 19 10 19s10-4.253 10-9.5S15.522 0 10 0zm2.195 8.576c-.095.437-1.486 2.848-1.891 3.663-.231.466-.685 1.113-.586 1.657.08.432.55.667.96.76.135.032.528.074.528.263 0 .077-.064.138-.145.14 0 .002-3.09.002-3.09.002-.44 0-.824-.297-.88-.713-.063-.468.27-.889.47-1.289.432-.858.923-1.69 1.352-2.55.155-.31.298-.625.455-.933.157-.307.352-.656.222-1.004-.139-.37-.6-.557-.973-.643-.135-.03-.528-.073-.528-.261 0-.078.065-.139.146-.14 0-.003 3.09-.003 3.09-.003.456 0 .869.34.893.773a1.04 1.04 0 0 1-.023.278zm-.707-1.922c-.789 0-1.428-.608-1.428-1.358 0-.749.64-1.357 1.428-1.357.788 0 1.429.608 1.429 1.357 0 .75-.64 1.358-1.429 1.358z"
      fillRule="nonzero"
      fill="currentColor"
    />
  </svg>
)

export default Info
